module.exports = __webpack_public_path__ + "img/like.85d9fb04.png";